import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  height: 48px;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  outline: none;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-family: "sofia-pro";
`;
